import { BaseOrganizationEndpoints } from "./base";

export type ApiToken = {
  id: string;
  organization_id: string;
  name: string;
  description: string | null;
  token: string | null;
  is_enabled: boolean;
  is_deleted: boolean;
  created_by_user_id: string;
  updated_by_user_id: string;
  deleted_by_user_id: string | null;
  deleted: string | null;
  expires_at: string | null;
  last_used_at: string | null;
  created_at: string;
  updated_at: string;
};

export type CreateApiTokenPayload = {
  name: string;
  description?: string | null;
  expires_at?: string | null;
};

export type UpdateApiTokenPayload = {
  name?: string;
  description?: string | null;
  is_enabled?: boolean;
  expires_at?: string | null;
};

export type ApiTokenListResponse = {
  tokens: ApiToken[];
};

const BASE_PATH = "/v1/api-tokens";

export class ApiTokensClient extends BaseOrganizationEndpoints {
  async list() {
    return this.requestWithStatus<ApiTokenListResponse>("GET", BASE_PATH);
  }

  async get(id: string) {
    return this.requestWithStatus<ApiToken>("GET", `${BASE_PATH}/${id}`);
  }

  async create(payload: CreateApiTokenPayload) {
    return this.requestWithStatus<ApiToken>("POST", BASE_PATH, payload);
  }

  async update(id: string, payload: UpdateApiTokenPayload) {
    return this.requestWithStatus<ApiToken>(
      "PATCH",
      `${BASE_PATH}/${id}`,
      payload
    );
  }

  async revoke(id: string) {
    return this.requestWithStatus<ApiToken>("DELETE", `${BASE_PATH}/${id}`);
  }
}
